<template>
  <div class="submenu-sections">
    <ul class="submenu-sections">
      <router-link tag="li" :to="{name:'LibraryAdvancedSearchQuery'}">
        <a>
          <h4><span class="text">Query</span></h4>
        </a>
      </router-link>
      <router-link tag="li" :to="{name:'LibraryAdvancedSearchResults'}">
        <a>
          <h4><span class="text">Results</span>
          </h4>
        </a>
      </router-link>
    </ul>
    <Pagination
        :pagination="pagination"
        :sizes="[100, 250, 500, 1000]"
        @page="handlePagination"
        @page-size="handlePageSize"
    />
  </div>
</template>

<script>
  import Pagination from '@/components/common/Pagination'
  import {mapState} from 'vuex'
  import EventBus from '@/eventbus'
  export default {
    components : { Pagination },
    computed: {
      ...mapState({
          pagination : state => state.advancedSearch.pagination
      }),
    },
    methods: {
        handlePagination (page) {
            EventBus.$emit("onTracksSearch", page)
        },
        handlePageSize (pageSize) {
            this.$store.dispatch('advancedSearch/setPaginationPageSize', pageSize)
            EventBus.$emit("onTracksSearch", 1)
        }
    }
  }
</script>

<style lang="scss" scoped>
  .badge-grey{
    background: #d2d2d2;
    padding: 5px;
    margin-left: 10px;
  }
</style>
